import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DfFocusStackService } from './focus-stack.service';
import { IdGeneratorService } from './id-generator.service';
import { DfPositioningService } from './positioning.service';

@NgModule({
  imports: [CommonModule],
  declarations: [],
  providers: [DfFocusStackService, DfPositioningService, IdGeneratorService],
  exports: [],
})
export class DfLayoutModule {}
